import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type AdvertisementFragment from "./AdvertisementFragment";
import type MentionReview from "./MentionReview";

@Model()
class Advertisement extends ApplicationRecord {
  static jsonapiType = "advertisements";

  @Attr({ persist: false }) createdAt: string;

  @HasMany() fragments: AdvertisementFragment[];

  @BelongsTo() mentionReview: MentionReview;

  @Attr({ persist: false }) text: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default Advertisement;
